import styled from 'styled-components';

export const StyledWebsiteContent = styled.div`
  padding: 80px 0 0 0;
`;
